import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

// Template165: Aeropuertos de París. Todo desde backend.
// page.texts[0]=header, [1]=intro, [2]=nota | page.sections[0..2] (title, body, content HTML list) | page.images (airport-sticker), page.canvasImages (logo)
const Template165 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;
	const contentColor = textColor || "#444";

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found) return found.src ?? found.url;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found) return found.imageUrl ?? found.url;
		}
		return undefined;
	};

	const headerText = page?.texts?.[0]?.content;
	const introText = page?.texts?.[1]?.content;
	const notaText = page?.texts?.[2]?.content;

	const sections = Array.isArray(page?.sections)
		? page.sections
		: Array.isArray(page?.data?.sections)
			? page.data.sections
			: Array.isArray(page?.data?.data?.sections)
				? page.data.data.sections
				: [];
	const section0 = sections[0];
	const section1 = sections[1];
	const section2 = sections[2];

	const logoImage = getCanvasImageUrl("logo");
	const airportStickerImage = getImageSrc("airport-sticker");

	const actualHeaderColor = headerBackgroundColor || "#2C3E50";
	const ff = fontFamily || "'Poppins', sans-serif";

	const h3Style = {
		fontFamily: `${ff} !important`,
		fontSize: "14px",
		fontWeight: 700,
		textTransform: "uppercase",
		marginBottom: "8px",
		marginTop: 0,
		color: "#2C3E50",
	};

	const pStyle = {
		fontFamily: `${ff} !important`,
		fontSize: "13px",
		color: contentColor,
		margin: 0,
	};

	const boxStyle = {
		backgroundColor: "#E8F4F8",
		border: "2px solid #2C3E50",
		borderRadius: "16px",
		padding: "16px",
	};

	const ulStyle = { paddingLeft: "18px", margin: 0 };

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				height: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				fontFamily: `${ff} !important`,
				position: "relative",
				"& *:not([data-template-header])": {
					fontFamily: `${ff} !important`,
					color: "inherit",
				},
			}}
		>
			{headerText && (
				<Box
					data-block-id="header"
					data-template-header
					sx={{
						backgroundColor: actualHeaderColor,
						color: headerTextColor || "#fff",
						textAlign: "center",
						padding: "15px 0",
						fontFamily: `${ff} !important`,
						fontSize: "14px",
						fontWeight: 600,
						flexShrink: 0,
						position: "sticky",
						top: 0,
						zIndex: 99999,
					}}
				>
					{headerText}
					{!isSmallScreen && logoImage && (
						<img
							src={logoImage}
							alt=""
							style={{
								width: 80,
								position: "absolute",
								right: 2,
								top: 18,
								zIndex: 999999,
							}}
						/>
					)}
				</Box>
			)}

			{introText && (
				<Box data-block-id="text-1" sx={{ padding: "12px 16px", fontSize: 13, color: contentColor }}>
					<Box component="p" sx={pStyle}>
						{introText}
					</Box>
				</Box>
			)}

			<Box
				sx={{
					padding: "0 16px 20px",
					display: "flex",
					flexDirection: "column",
					gap: "8px",
					position: "relative",
					fontSize: "13px",
				}}
			>
				{section0 && (
					<Box data-block-id="text-2" sx={boxStyle}>
						{section0.title && (
							<Box component="h3" sx={{ ...h3Style, fontSize: "13px" }}>
								{section0.title}
							</Box>
						)}
						{section0.body && (
							<Box component="p" sx={{ ...pStyle, marginBottom: "8px" }}>
								{section0.body}
							</Box>
						)}
						{section0.content && (
							<Box
								component="div"
								dangerouslySetInnerHTML={{ __html: section0.content }}
								sx={ulStyle}
							/>
						)}
					</Box>
				)}

				{section1 && (
					<Box data-block-id="text-3" sx={boxStyle}>
						{section1.title && (
							<Box component="h3" sx={{ ...h3Style, fontSize: "13px" }}>
								{section1.title}
							</Box>
						)}
						{section1.body && (
							<Box component="p" sx={{ ...pStyle, marginBottom: "8px" }}>
								{section1.body}
							</Box>
						)}
						{section1.content && (
							<Box
								component="div"
								dangerouslySetInnerHTML={{ __html: section1.content }}
								sx={ulStyle}
							/>
						)}
					</Box>
				)}

				{section2 && (
					<Box data-block-id="text-4" sx={boxStyle}>
						{section2.title && (
							<Box component="h3" sx={{ ...h3Style, fontSize: "13px" }}>
								{section2.title}
							</Box>
						)}
						{section2.body && (
							<Box component="p" sx={{ ...pStyle, marginBottom: "8px" }}>
								{section2.body}
							</Box>
						)}
						{section2.content && (
							<Box
								component="div"
								dangerouslySetInnerHTML={{ __html: section2.content }}
								sx={ulStyle}
							/>
						)}
					</Box>
				)}

				{notaText && (
					<Box
						data-block-id="text-5"
						sx={{
							backgroundColor: "#fff8db",
							border: "2px solid #f5c400",
							borderRadius: "12px",
							padding: "12px 14px",
							fontSize: 13,
							fontFamily: `${ff} !important`,
							paddingBottom: "8px",
						}}
					>
						{notaText}
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template165.thumbnail = "/images/template-1.png";

export default Template165;
